import React from 'react';
import { useNavigate } from 'react-router-dom';
import './css/Daily.css';

const Settings = () => {
    const navigate = useNavigate();

    return (
        <div className="wrapper supportScreen">
            <div className="supportSurface">
                <div className="supportHeader">
                    <h2 className="dailyMainTitle">Trampoline Health Settings</h2>
                    <p className="inDevelopmentCopy">
                        Notifications, your data, and information about Trampoline.
                    </p>
                </div>

                <div className="supportSectionCard">
                    <h5 className="supportSectionTitle">Application Settings</h5>
                    <div className="homeBttnContainer supportActions">
                        <button
                            type="button"
                            className="homeBttn"
                            onClick={() => navigate('/notifications')}
                        >
                            Notifications
                        </button>
                        <button
                            type="button"
                            className="homeBttn"
                            onClick={() => navigate('/in-development')}
                        >
                            Security & Data
                        </button>
                        <button
                            type="button"
                            className="homeBttn"
                            onClick={() => navigate('/manage-membership')}
                        >
                            Manage Membership
                        </button>
                        <button
                            type="button"
                            className="homeBttn"
                            onClick={() => navigate('/about')}
                        >
                            About Trampoline
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Settings;
